import React from 'react'
import RegisterUser from '../../Components/AdminComponents/RegisterUser.jsx'

const UserRegisterPage = () => {
  return (
    <div><RegisterUser /></div>
  )
}

export default UserRegisterPage